import { render, staticRenderFns } from "./undo.vue?vue&type=template&id=5dbf17f6&scoped=true&"
import script from "./undo.vue?vue&type=script&lang=js&"
export * from "./undo.vue?vue&type=script&lang=js&"
import style0 from "./undo.vue?vue&type=style&index=0&id=5dbf17f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf17f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
